export const CATEGORY = 'category';
export const STATUS = 'status';
export const DATE = 'date';
export const LOCATION = 'location';
export const SEARCH = 'search';
